// extracted by mini-css-extract-plugin
export default {"comment-view-header":"styles__comment-view-header___TghQz"};